import { render } from "./InventoryInactiveList.vue?vue&type=template&id=74181b04&scoped=true"
import script from "./InventoryInactiveList.vue?vue&type=script&lang=js"
export * from "./InventoryInactiveList.vue?vue&type=script&lang=js"

import "./InventoryInactiveList.vue?vue&type=style&index=0&id=74181b04&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74181b04"]])

export default __exports__